'use client';

import { useAtomValue } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';

import type { HeroCampaignBanner as HeroCampaignBannerType } from '../Entities/CampaignBanner.entity';
import { HeroCampaignBanner } from '../HeroCampaignBanner/HeroCampaignBanner';
import { getCorrectBanner } from '../Utils/CampaignBanner.utils';

export type HeroCampaignBannerPickerProps = {
  activeHeroCampaignBanners: HeroCampaignBannerType;
  locale: Locale;
  pageType: string | undefined;
};

export const HeroCampaignBannerPicker = ({
  locale,
  activeHeroCampaignBanners,
  pageType,
}: HeroCampaignBannerPickerProps) => {
  const filters = useAtomValue(filtersListAtom);
  const isEcom = getFilterFromArray('ecom', filters);
  const isD2d = getFilterFromArray('d2c', filters);

  const banner = getCorrectBanner(
    activeHeroCampaignBanners,
    isEcom?.value === 'true',
    isD2d?.value === 'true',
  );

  return <HeroCampaignBanner {...banner} locale={locale} bannerLoc={pageType} />;
};

HeroCampaignBannerPicker.displayName = 'HeroCampaignBannerPicker';
